import { pageT } from '../../../i18n/page.i18n';

export const BaseProfiles: Record<string, string> = {
    allstaff: pageT('profileYandexNDA'),
    allstaff_outstaf: pageT('profileYandexBSTNDA'),
    allstaff_outstaff_ext: pageT('profileYandexBSTConsultantsNDA'),
} as const;
